import { Button, Grid } from "@mui/material";
import clsx from "clsx";
import React, { memo } from "react";
const ButtonRight = (props) => {
  const {
    id,
    text,
    onNextPage,
    isDisbled,
    disbled,
    BtnSecondary,
    hide,
    wrapperStyle,
    btnStyle,
    variant,
  } = props;
  return (
    <Grid
      className={clsx(hide && "hide", "box-btn-next ")}
      sx={{
        display: "flex",
        justifyContent: "center", // จัดกลางแนวนอน
        alignItems: "center",
        ...wrapperStyle,}}
    >
      <Button
        id={id}
        className={clsx(
          BtnSecondary ? "btn-secondary-cancel" : "btn-primary",
          "font-20",
          isDisbled && !disbled && "disabled",
        )}
        onClick={onNextPage}
        disabled={isDisbled && !disbled}
        sx={btnStyle}
        variant={variant ?? "outlined"}
      >
        {text}
      </Button>
    </Grid>
  );
};
export default memo(ButtonRight);
